import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextHypmono } from "./TextHypmono";
import { SourcesHypmono } from "./SourcesHypmono";

export default function Hypmono() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Monogenic Genes' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Hypertension monogenic genes - Variants'

        content={<TextHypmono />}

        sources={<SourcesHypmono />}

/>

</>
)}